import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Box, Typography } from '@mui/material';

import { GlobalContext } from '../context/GlobalState';
import { useContext } from 'react';

// Selectable option card: the whole row is the click target and the chosen one is outlined in gold
// over a soft gold wash, rather than a bare radio dot in a list. `error` outlines every card in red
// when the customer tried to order without choosing.
export const optionCardSx = (selected, error = false) => ({
  m: 0,
  mb: 1.25,
  width: '100%',
  alignItems: 'center',
  borderRadius: 1,
  border: '1px solid',
  borderColor: selected ? 'gold.fill' : error ? 'error.main' : 'divider',
  backgroundColor: selected ? 'gold.soft' : 'background.default',
  px: 1.5,
  py: 1.25,
  transition: 'border-color 0.2s ease, background-color 0.2s ease',
  '&:hover': { borderColor: selected ? 'gold.fill' : error ? 'error.main' : 'hairline.strong' },
  '& .MuiFormControlLabel-label': { width: '100%' }
});

// Shown under a group when the customer submitted without picking.
export const ChoiceError = ({ message }) => (
  <Typography role="alert" sx={{ color: 'error.main', fontSize: 13, mt: 0.5, mb: 1 }}>
    {message}
  </Typography>
);

export default function RadioButtonsGroup({ values, error = false }) {
  const { shippingOption, selectShippingOption } = useContext(GlobalContext);

  const [resultSelected, setResultSelected] = React.useState(shippingOption.name);

  const handleValueChange = (event) => {
    let selectedValue = event.target.value;
    setResultSelected(selectedValue);

    let selectedOption = values?.filter((item) => item.name === selectedValue)[0];

    selectShippingOption(selectedOption);
  };

  return (
    <FormControl fullWidth>
      <RadioGroup
        aria-label="Начин на доставка"
        name="shipping-options"
        value={resultSelected}
        onChange={handleValueChange}>
        {values.map((item) => {
          const selected = resultSelected === item.name;
          return (
            <FormControlLabel
              key={item.name}
              value={item.name}
              sx={optionCardSx(selected, error)}
              control={<Radio size="small" color={error ? 'error' : 'primary'} />}
              label={
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'baseline',
                    flexWrap: 'wrap',
                    gap: 1,
                    width: '100%'
                  }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'text.primary' }}>
                    {item.name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 14,
                      color: 'text.primary',
                      whiteSpace: 'nowrap',
                      fontVariantNumeric: 'tabular-nums'
                    }}>
                    {item.price_eur} EUR
                  </Typography>
                </Box>
              }
            />
          );
        })}
      </RadioGroup>
      {error && <ChoiceError message="Моля, изберете начин на доставка." />}
    </FormControl>
  );
}
